import { variables } from './variables';

//console log
const cl = e => {
  console.log(e);
};

// Random Color generator
const getRandomColor = () => {
  let letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

// Degree --> Decimal converter
const dmsToLonLat = o => {
  let n = NaN;
  if (o) {
    let t = Number(o.degree),
      d = 'undefined' != typeof o.minute ? Number(o.minute) / 60 : 0,
      l = 'undefined' != typeof o.second ? Number(o.second) / 3600 : 0,
      r = o.direction || null;
    null !== r && /[SW]/i.test(r) && (t = -1 * Math.abs(t)), (n = 0 > t ? t - d - l : t + d + l);
  }
  return n;
};

//Mobile operating device detect
const getMobileOperatingSystem = () => {
  let userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return 'Windows Phone';
  }

  if (/android/i.test(userAgent)) {
    return 'Android';
  }

  // IOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'IOS';
  }

  return 'unknown';
};

const urlMapsSelector = (lat, long) => {
  let url;
  if (mobileOperatingSystem === 'IOS') {
    url = `maps://maps.google.com/maps?daddr=${lat},${long}&amp;ll=`;
  } else {
    url = `https://maps.google.com/maps?daddr=${lat},${long}&amp;ll=`;
  }
  return url;
};

//Sorting function
const sortArray = data => {
  data = data.sort((a, b) => {
    let nameA = a.name.toUpperCase();
    let nameB = b.name.toUpperCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  });
  return data;
};

//First letter capitalize
const capitalizeFirstLetter = string => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

//Remove doublons from array
const getUnique = array => {
  let uniqueArray = [];
  // Loop through array values
  for (let i = 0; i < array.length; i++) {
    if (uniqueArray.indexOf(array[i]) === -1) {
      uniqueArray.push(array[i]);
    }
  }
  return uniqueArray;
};

const convertLong = e => {
  let longStr = e.toString();
  let dmsToLonLatRegex = /[-]{0,1}[\d.]*[\d]|([NSEW])+/g;
  let longParsed = longStr.match(dmsToLonLatRegex);
  if (longParsed !== null) {
    let longParsedObj = {
      long: {
        degree: longParsed[0],
        minute: longParsed[1],
        second: longParsed[2],
        direction: longParsed[3]
      }
    };
    return longParsedObj;
  }
};

const convertLat = e => {
  let latStr = e.toString();
  let dmsToLonLatRegex = /[-]{0,1}[\d.]*[\d]|([NSEW])+/g;
  let latParsed = latStr.match(dmsToLonLatRegex);
  if (latParsed !== null) {
    let latParsedObj = {
      lat: {
        degree: latParsed[0],
        minute: latParsed[1],
        second: latParsed[2],
        direction: latParsed[3]
      }
    };
    return latParsedObj;
  }
};

const trimToLowerCase = e => {
  e = e.split(/\s/).join('');
  e = e.toLowerCase();
  return e;
};

const toggleMapList = (elementToSelect, elementToDeselect, elementToShow, elementToHide) => {
  if (elementToHide !== null && elementToShow !== null && elementToSelect !== null && elementToDeselect !== null) {
    elementToHide.style.display = 'none';
    elementToShow.style.display = 'block';
    elementToDeselect.classList.remove('selected');
    elementToSelect.classList.add('selected');
  }
};

const convertHexToRGBA = (hexCode, opacity) => {
  let hex = hexCode.replace('#', '');

  if (hex.length === 3) {
    hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
  }

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  return `rgba(${r},${g},${b},${opacity})`;
};

// OverlayScrollbar INIT
const makeScrollbar = (element, theme, fade) => {
  let instance = OverlayScrollbars(element, {
    className: theme,
    scrollbars: {
      autoHide: 'leave',
      autoHideDelay: 400
    },
    callbacks: {
      onInitialized: function (e) {
        if (fade === true) {
          let topFade = document.createElement('div');
          topFade.setAttribute('class', 'scroll-topFade');
          topFade.style.opacity = '0';
          let bottomFade = document.createElement('div');
          bottomFade.setAttribute('class', 'scroll-bottomFade');
          element.prepend(topFade, bottomFade);
        }
      },
      onScroll: function (e) {
        element.dataset.scrollposition = this.scroll().position.y;
        if (fade === true) {
          let scroll_y = this.scroll().ratio.y;
          let topFade = element.querySelectorAll('.scroll-topFade')[0];
          let bottomFade = element.querySelectorAll('.scroll-bottomFade')[0];
          if (scroll_y > 0.9) {
            let scroll_y_opacity = 10 - scroll_y * 10;
            bottomFade.style.opacity = scroll_y_opacity;
          }
          if (scroll_y < 0.1) {
            let scroll_y_opacity = scroll_y * 10;
            topFade.style.opacity = scroll_y_opacity;
          }
          if (scroll_y > 0.1 && scroll_y < 0.9) {
            topFade.style.opacity = '1';
            bottomFade.style.opacity = '1';
          }
        }
      }
    }
  });
}

const mobileOperatingSystem = getMobileOperatingSystem();

// Main ajax function
const ajax = (params, successFunction, errorFunction, ajaxType) => {
  if (window.fetch) {
    Object.keys(params).forEach(key => variables.url.searchParams.append(key, params[key]));
    // prettier-ignore
    return fetch(variables.url, {
      headers: {
        'Content-Type': ajaxType === 'json'
          ? 'application/json; charset=utf-8'
          : ajaxType === 'text'
            ? 'charset=utf-8'
            : undefined
      }
    })
      .then(
        response => ajaxType === 'json'
          ? response.json()
          : ajaxType === 'text'
            ? response.text()
            : undefined
      )
      .then(successFunction)
      .catch(errorFunction);
  } else {
    if (window.jQuery) {
      const $ = jQuery.noConflict();
      // prettier-ignore
      return $.ajax({ //Backup JQuery sur IE
        dataType: ajaxType === 'json'
          ? 'json'
          : ajaxType === 'text'
            ? 'html'
            : undefined,
        url: variables.url,
        data: params,
        success: successFunction,
        error: errorFunction
      });
    }
  }
};

const makeSVGGradient = (array) => {
  let gradient = ``;
  if (!!array.length) {
    if (array.length === 1) {
      gradient = /*html*/ `
        <stop offset="0%" stop-color="${array[array.length - 1]}"/>
        <stop offset="100%" stop-color="${array[array.length - 1]}"/>`;
    } else if (array.length === 2) {
      gradient = /*html*/ `
        <stop offset="0%" stop-color="${array[0]}"/>
        <stop offset="100%" stop-color="${array[1]}"/>`;
    } else if (array.length > 2) {
      for (let i = 0; i < array.length; i++) {
        if (i !== array.length - 1) {
          gradient += /*html*/ `<stop offset="${i === 0 ? 0 : Math.round((100 / (array.length - 1)) * i)}%" stop-color="${array[i]}"/>`;
        }
      }
      gradient += /*html*/ `<stop offset="100%" stop-color="${array[array.length - 1]}"/>`;
    }
  }
  return gradient;
}
export {
  cl,
  dmsToLonLat,
  getRandomColor,
  mobileOperatingSystem,
  urlMapsSelector,
  sortArray,
  capitalizeFirstLetter,
  getUnique,
  convertLong,
  convertLat,
  trimToLowerCase,
  toggleMapList,
  convertHexToRGBA,
  makeScrollbar,
  ajax,
  makeSVGGradient
};
